import myProgramContext from './my-program-context';

export default {
  ...myProgramContext,
};
